<template>
  <div class="page-content">
    <!-- 页面标题区域 -->
    <div class="page-header d-flex d-flex-between d-flex-middle">
      <div class="page-title d-flex d-flex-middle">
        <span class="title-bar"></span>
        <span class="title-text">修改信息</span>
      </div>
      <a href="javascript:void(0)" class="back-link" @click="handlePrev"><em style="position: relative;top: -1px;">&lt;</em> 返回</a>
    </div>
        <div class="progressBox" v-if="!showMajorPlanDetail">
          <BmProgress :steps="steps" :current-step="1" />
        </div>
        <div class="contentBox" :class="{ 'full-width': showMajorPlanDetail }">
          <SelectMajor 
            v-if="!showMajorPlanDetail" 
            :selectedSpecialtyId="selectedSpecialtyId"
            @prev-step="handlePrev" 
            @next-step="handleNext" 
            @view-plan="handleViewPlan" 
          />
          <planDetail 
            v-else 
            :specId="specId" 
            @back="handleBackFromPlanDetail"
            @register="handleRegisterFromPlanDetail"
            :showBack="false"
          />
        </div>
        
        <!-- 底部跳过按钮 -->
        <div class="button-section" v-if="!showMajorPlanDetail">
          <el-button class="skip-btn" @click="handleSkip">跳过</el-button>
        </div>
  </div>
</template>

<script>
import BmProgress from "@/components/bm/bmProgress.vue";
import SelectMajor from "@/components/bm/selectMajor.vue";
import planDetail from "@/components/bm/planDetail.vue";

export default {
  name: 'Step2SelectMajor',
  components: {
    BmProgress,
    SelectMajor,
    planDetail
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      steps: [
        { title: '选择就读地点' },
        { title: '选择报名专业' },
        { title: '注册资料' },
        { title: '提交报名' },
      ],
      showMajorPlanDetail: false,
      specId: null,
      selectedSpecialtyId: null
    }
  },
  created() {
    // 参考 xnkd-student-h5 的 editInfo.vue：加载学生信息并回显专业
    this.loadStudentInfo()
  },
  methods: {
    // 加载学生信息，参考 xnkd-student-h5 的 editInfo.vue
    loadStudentInfo() {
      this.$http.get(this.MOCK_PREFIX + '/student/pc/register/queryStudentInfo?target_id=22b542ab707097').then(res => {
        if (res) {
          // 步骤1数据回填：根据接口返回的专业信息设置
          if (res.specialtyId || res.specialtyCode || res.specialtyName) {
            const specialtyId = res.specialtyId || ''
            this.selectedSpecialtyId = specialtyId
            
            // 保存到 localStorage
            if (specialtyId) {
              localStorage.setItem('specId', specialtyId)
              // 保存专业信息到 localStorage
              const specInfo = {
                id: specialtyId,
                code: res.specialtyCode || '',
                name: res.specialtyName || '',
                edulevel: res.eduLevel || ''
              }
              localStorage.setItem('specInfo', JSON.stringify(specInfo))
            }
          } else {
            // 如果接口没有专业信息，尝试从 localStorage 加载
            const specIdStr = localStorage.getItem('specId')
            if (specIdStr) {
              this.selectedSpecialtyId = specIdStr
            }
          }
        }
      }).catch(err => {
        console.error('获取学生信息失败:', err)
      })
    },
    // 返回按钮点击事件
    handleBack() {
      this.$router.push({ name: 'mineBmSelectLocation' })
    },
    handlePrev() {
      if (this.showMajorPlanDetail) {
        this.handleBackFromPlanDetail()
      } else {
        this.$router.push({ name: 'mineBmSelectLocation' })
      }
    },
    handleNext(id) {
      localStorage.setItem('specId', id)
      this.$router.push({ name: 'mineBmRegisterInfo' })
    },
    handleViewPlan(id) {
      this.specId = id
      this.showMajorPlanDetail = true
    },
    handleBackFromPlanDetail() {
      this.showMajorPlanDetail = false
      this.specId = null
    },
    handleRegisterFromPlanDetail(id) {
      localStorage.setItem('specId', id)
      this.showMajorPlanDetail = false
      this.$router.push({ name: 'mineBmRegisterInfo' })
    },
    handleSkip() {
      // 跳过选择专业，直接跳转到注册资料页面
      this.$router.push({ name: 'mineBmRegisterInfo' })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  padding: 0 30px;
  min-height: 500px;
}

.page-header {
  height: 80px;
  line-height: 80px;
  padding: 0;
  border-bottom: 1px solid #F2F2F2;
  margin-bottom: 40px;
  .page-title {
    padding: 0;
    .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0 !important;
        margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
  .back-link{
    font-size: 14px;
    color: #767676;
    cursor: pointer;
  }
}

.button-section {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  margin-top: 20px;

  .skip-btn {
    width: 160px;
    height: 40px;
    border-radius: 6px;
    font-size: 16px;
    background: #4084FF;
    color: #fff;
    border: 1px solid #4084FF;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background: #f5f5f5;
      border-color: #1687DE;
      color: #1687DE;
    }
  }
}
</style>
